import { render, staticRenderFns } from "./CreateInfo.vue?vue&type=template&id=43b219d2&scoped=true"
import script from "./CreateInfo.vue?vue&type=script&lang=js"
export * from "./CreateInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateInfo.vue?vue&type=style&index=0&id=43b219d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b219d2",
  null
  
)

export default component.exports